// extracted by mini-css-extract-plugin
export default {"Container":"Attribute_Container__Hie4J","Divider":"Attribute_Divider__622lM"};